module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_warn_tick-89f03d9959d440f8e35da704329e9ffe.png";